import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { AngularMultiSelect } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { CustomerServiceConstants } from "../../../common/constants/customer-service.constants";
import { AccessLevel } from "../../../common/enums/access-level.enum";
import { MessageService } from "../../../shared/services/message.service";
import { NotificationType } from "../../enums/notification-types.enum";
import { ManageUserTab } from "../../models/manage-user-tab-model";
import { DepartmentService } from "../../services/department.service";
import { CacheKey } from './../../../shared/constants/cachekey.constants';
import { CacheService } from "./../../../shared/services/cache.service";
import { CommonService } from "./../../../shared/services/common.service";
import { CommonConfig } from './../../common/common.config';
import { RowStatus } from "./../../common/enumerations";
import { DeleteModal } from './../../models/delete-modal';
import { Permission } from "./../../models/permission";
import { PermissionGroup } from "./../../models/permission-group";
import { User } from "./../../models/user";
import { UserRolePermissions } from "./../../models/user-role-permission";
import { MULTI_SELECT_CONFIG } from './../../selectize/selectize.config';

@Component({
    selector: "department-manage-user",
    templateUrl: "../../templates/template1/views/department/department-manage-user.component.html",
    styleUrls: ["../../templates/template1/themes/default/css/department.less"],

})
export class DepartmentManangeUserComponent implements OnInit {
    @Input() departmentId: number;
    @Input() userId: number;
    @Input() operatingCountryId:number;
    userAssignForm: FormGroup;
    userUpdateForm: FormGroup;
    updateUser: User = new User();
    isAssignUserSection: Boolean = true;
    rolesDropdownConfig: any;
    departmentLevelPermissionGroupList: PermissionGroup[] = [];
    permissionGroupList: PermissionGroup[] = [];
    multiSelectValue: number[] = [];
    userName: String;
    message: string = '';
    chechBoxChecked: number[];
    permissionHeaders: String[] = [];
    permissionGroupListToBeSelected: PermissionGroup[];
    totalPermissions: String[] = CustomerServiceConstants.TOTAl_PERMISSIONS;
    permissionIdStrings: String[] = [];
    userRolePermissionDetails: UserRolePermissions;
    dynamicMultiSelectValues: number[] = [];
    permissions: Permission[];
    showSuccess: boolean = false;
    showFailure: boolean = false;
    rowStateValue: number;
    deleteModal: DeleteModal;
    loginId: string;
    email: string;
    phoneNumber: string;
    roles: any[];
    roleOnSelectAll: boolean = true;
    roleIds:any[];
    assignedRolesInfo:any[];
    isRolesSelected:boolean=false;
    @ViewChild('dropdownElem') dropdownElem: AngularMultiSelect;

   public dropdownSettings: any = {
        rolesDropdown: [],
        roleSelectedItems: [],
        roleIndex: 1,        
        settings: {}, 
    };

    constructor(
        private _formBulider: FormBuilder,
        private _translatePipe: TranslateService,
        private _cacheService: CacheService,
        private _commonService: CommonService,
        private _departmentService: DepartmentService,
        private cdRef: ChangeDetectorRef,
        private messageService: MessageService
    ) {
    }

    ngOnInit() {
        this.deleteModal = new DeleteModal(this.clearData.bind(this), this.closeDeleteMessage.bind(this), this.closeDeleteMessage.bind(this));
        this.deleteModal.viewActionButtons = true;
        
        if (this.userId > 0) {
            this.initializeUpdateUserForm();
            this.getUserById(this.departmentId, this.userId);
        }
         this.dropdownSettings.settings = {
            singleSelection: false,
            text: "Select Role",
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            enableSearchFilter: false,
            classes: "myclass custom-class",
            badgeShowLimit: 1
        };        

    }

    initializeUpdateUserForm() {
        this.userUpdateForm = this._formBulider.group(
            {
                roleUpdateIds: ["", Validators.required],
            });
        this.bindDepartmentLevelRoles();
    }

    bindDepartmentLevelRoles() {   
    this.rolesDropdownConfig = MULTI_SELECT_CONFIG;
    this._departmentService.getRoles().subscribe((response: any) => {
       if (response) {
          this.roles = response;              
          this.roles.forEach(item => {
              this.dropdownSettings.rolesDropdown.push({ id: item.id, itemName: item.name });
          }); 
          this.dropdownSettings.roleSelectedItems= JSON.parse(JSON.stringify(this.dropdownSettings.rolesDropdown));
      }
    });
   }

   closeDeleteMessage(): void {
    this.rowStateValue = null;
  }

  clearData(): void {
    if (this.userId > 0) {
      this.isAssignUserSection = false;
      this.getUserById(this.departmentId, this.userId)
    }
    else {
      this.isAssignUserSection = true;
      this.userAssignForm.patchValue({
        unassignedUserId: [""],
        description: [""],
        roleIds: [""],
      });
    }
  }

    getUserById(departmentId: any, userId: any) {
     
    this._departmentService.getUserById(departmentId, userId).subscribe(response => {
      if (response) {
        this.roleIds = [];
        this.assignedRolesInfo =[];
        this.userRolePermissionDetails = response;
        this.loginId = this.userRolePermissionDetails.userName === undefined || this.userRolePermissionDetails.userName===null || this.userRolePermissionDetails.userName===""?"NA":this.userRolePermissionDetails.userName;
        this.userName = this.userRolePermissionDetails.userName===undefined ||this.userRolePermissionDetails.userName===null || this.userRolePermissionDetails.userName===""?"NA":this.userRolePermissionDetails.userName ;
        this.email = this.userRolePermissionDetails.email === undefined || this.userRolePermissionDetails.email === null || this.userRolePermissionDetails.email === "" ?"NA":this.userRolePermissionDetails.email;
        this.phoneNumber = this.userRolePermissionDetails.phone === undefined || this.userRolePermissionDetails.phone === null || this.userRolePermissionDetails.phone === ""?"NA":this.userRolePermissionDetails.phone;
        this.multiSelectValue = [];
        if (this.userRolePermissionDetails.roles && this.userRolePermissionDetails.roles.length > 0) {
          this.userRolePermissionDetails.roles.forEach(role => {
            this.multiSelectValue.push(role.id);            
          });
            this.userRolePermissionDetails.roles.forEach(item => {
              this.assignedRolesInfo.push({ id: item.id, itemName: item.name });
              this.roleIds.push(item.id);
          }); 
          
           this.dropdownSettings.roleSelectedItems= JSON.parse(JSON.stringify(this.assignedRolesInfo));
        }
        else { }
        this.dynamicMultiSelectValues = this.multiSelectValue;
        this.permissionGroupListToBeSelected = this.userRolePermissionDetails.permissionGroups;
        this.getPermissionsByRoleLevelId([AccessLevel.Department, AccessLevel.CMS]);
      }
    })
  }

  getPermissionsByRoleLevelId(roleLevelIds: number[]) {
    this.chechBoxChecked = [];
    this._departmentService.getPermissionsByAccessLevelIds(roleLevelIds).subscribe(response => {
      this.permissionGroupList = response;
      this.departmentLevelPermissionGroupList = this.permissionGroupList.filter(item => item.accessLevelId === AccessLevel.Department)
      this.departmentLevelPermissionGroupList.forEach(group => {
        let currentGroupPermissionsCount = group.permissionModels.length;
        let permissionNames: String[] = [];
        group.permissionModels.forEach(item => {
          let index: number = this.permissionHeaders.indexOf(item.permissionName);
          if (index === -1) {
            this.permissionHeaders.push(item.permissionName);
          }
          if (this.permissionGroupListToBeSelected != null && this.permissionGroupListToBeSelected.length > 0) {
            this.permissionGroupListToBeSelected.forEach(parent => {
              if (parent.permissionGroupId === group.permissionGroupId && currentGroupPermissionsCount > 0 && currentGroupPermissionsCount === parent.permissionModels.length) {
                group.selected = true;
              }
              parent.permissionModels.forEach(child => {

                if (item.permissionId === child.permissionId) {
                  item.selected = true;
                  item.rolePermissionId = child.rolePermissionId;
                  this.chechBoxChecked.push(child.permissionId);
                }
              });
            });
          }
          if (item.selected) {
            // for CREATE permission
            if (item.permissionName === this.totalPermissions[0] || item.permissionName === this.totalPermissions[5]) {

              permissionNames.push(this.totalPermissions[1]);

              permissionNames.push(this.totalPermissions[2]);
            } // for EDIT permission
            else if (item.permissionName === this.totalPermissions[2]) {

              permissionNames.push(this.totalPermissions[1]);
            }// for DELETE/DEACTIVATE permission
            else if (item.permissionName === this.totalPermissions[3] || item.permissionName === this.totalPermissions[4]) {
              permissionNames.push(this.totalPermissions[1]);
            }
          }
        });
        if (permissionNames.length > 0) {
          permissionNames.forEach(name => {
            let permission = group.permissionModels.filter(item => item.permissionName === name)[0];
            if (permission != null) {
              this.permissionIdStrings.push(group.permissionGroupId + '-' + permission.permissionId)
            }
          });
        }
      });
    },
      // The 2nd callback handles errors.
      (err) => {},
      // The 3rd callback handles the "complete" event.
      () => {
        this.cdRef.detectChanges();
        this.setCheckboxesToDisableModeOnLoad();
      }
    );
  }

  setCheckboxesToDisableModeOnLoad() {
    if (this.permissionIdStrings != null && this.permissionIdStrings.length > 0) {
      this.permissionIdStrings.forEach(item => {
        let checkbox = document.getElementById('permission-' + item);
        var newAttr = document.createAttribute("disabled");
        newAttr.value = "disabled";
        checkbox.setAttributeNode(newAttr);
      });
      this.permissionIdStrings = [];
    }
  }

  isPermissionAvailable(permissions: Permission[], headerText: string): Boolean {
    if (permissions && headerText)
      return !(permissions.map(x => x.permissionName).indexOf(headerText) >= 0);
    else
      return false;
  }

  createSuccessClose() {
    this.showSuccess = false;
    this.showFailure = false;
  }

  groupCheckBox(permissionGroup: PermissionGroup, event: any) {
    if (event.target.checked) {
      permissionGroup.permissionModels.forEach(item => {
        let index: number = this.chechBoxChecked.indexOf(item.permissionId);
        item.selected = event.target.checked;
        if (index === -1) {
          this.chechBoxChecked.push(item.permissionId);
        }
        if (item.permissionName === this.totalPermissions[1] || item.permissionName === this.totalPermissions[2]) {
          this.permissionIdStrings.push(permissionGroup.permissionGroupId + '-' + item.permissionId)
        }
      });
      this.setCheckboxesToDisableModeOnLoad();
    }
    else {
      permissionGroup.permissionModels.forEach(element => {
        let index: number = this.chechBoxChecked.indexOf(element.permissionId);
        element.selected = false;
        if (index !== -1) {
          this.chechBoxChecked.splice(index, 1);
        }
        if (element.permissionName === this.totalPermissions[1] || element.permissionName === this.totalPermissions[2]) {
          this.permissionIdStrings.push(permissionGroup.permissionGroupId + '-' + element.permissionId)
        }
      });
      this.revertCheckboxesFromDisableModeOnLoad();
    }
  }

  revertCheckboxesFromDisableModeOnLoad() {

    if (this.permissionIdStrings != null && this.permissionIdStrings.length > 0) {
      this.permissionIdStrings.forEach(item => {
        let checkbox = document.getElementById('permission-' + item);
        checkbox.removeAttribute("disabled");
      });
      this.permissionIdStrings = [];
    }
  }

  updateCheckedOptions(permission: Permission, group: PermissionGroup, event: any) {

    if (event.target.checked) {
      permission.selected = true;
      if (this.chechBoxChecked)
        this.chechBoxChecked.push(permission.permissionId);
      this.setCheckboxesToCheckedStateWithDisableMode(permission, group);
    } else {
      permission.selected = false;
      let index: number = this.chechBoxChecked.indexOf(permission.permissionId);
      if (index !== -1) {
        this.chechBoxChecked.splice(index, 1);
      }
      this.revertCheckboxesFromCheckedStateWithDisableMode(permission, group);
    }

    let totalCheckboxes: number = group.permissionModels.length;
    let selectedCheckboxes: number = 0;

    group.permissionModels.forEach(item => {
      if (item.selected) {
        selectedCheckboxes++;
      }
    })
    group.selected = (selectedCheckboxes != totalCheckboxes ? false : true);

  }

  revertCheckboxesFromCheckedStateWithDisableMode(permission: Permission, group: PermissionGroup) {

    let permissionNames: String[] = []
    let permissions: Permission[] = group.permissionModels.filter(item => item.selected === true)
    let dependentPermissionNames: String[] = [];
    if (permissions != null && permissions.length > 0) {
      dependentPermissionNames = permissions.map(function (a) { return a.permissionName; });
    }

    if ((dependentPermissionNames.indexOf(this.totalPermissions[1]) != -1)
      && dependentPermissionNames.length === 1) {
      permissionNames.push(this.totalPermissions[1]);
    }
    else {
      // for CREATE permission
      if (permission.permissionName === this.totalPermissions[0] || permission.permissionName === this.totalPermissions[5]) {
        if (!((dependentPermissionNames.indexOf(this.totalPermissions[3]) != -1)
          || (dependentPermissionNames.indexOf(this.totalPermissions[4]) != -1)))

          permissionNames.push(this.totalPermissions[1]);

        permissionNames.push(this.totalPermissions[2]);

      } // for EDIT permission
      else if ((permission.permissionName === this.totalPermissions[2])
        && !((dependentPermissionNames.indexOf(this.totalPermissions[1]) != -1)
          || (dependentPermissionNames.indexOf(this.totalPermissions[3]) != -1)
          || (dependentPermissionNames.indexOf(this.totalPermissions[4]) != -1))) {

        permissionNames.push(this.totalPermissions[1]);

      }// for DELETE/DEACTIVATE permission
      else if ((permission.permissionName === this.totalPermissions[3] || permission.permissionName === this.totalPermissions[4])
        && !((dependentPermissionNames.indexOf(this.totalPermissions[2]) != -1)
          || (dependentPermissionNames.indexOf(this.totalPermissions[3]) != -1)
          || (dependentPermissionNames.indexOf(this.totalPermissions[4]) != -1))) {

        permissionNames.push(this.totalPermissions[1]);

      }
    }

    if (permissionNames.length > 0) {
      permissionNames.forEach(name => {
        let permission = group.permissionModels.filter(item => item.permissionName === name)[0];
        if (permission != null) {
          permission.selected = false;
          this.permissionIdStrings.push(group.permissionGroupId + '-' + permission.permissionId)
          let index: number = this.chechBoxChecked.indexOf(permission.permissionId);
          if (index !== -1) {
            this.chechBoxChecked.splice(index, 1);
          }
        }
      });
      this.revertCheckboxesFromDisableModeOnLoad();
    }
  }

  setCheckboxesToCheckedStateWithDisableMode(permission: Permission, group: PermissionGroup) {
    let permissionNames: String[] = []
    // for CREATE permission
    if (permission.permissionName === this.totalPermissions[0] || permission.permissionName === this.totalPermissions[5]) {
      permissionNames.push(this.totalPermissions[1]);
      permissionNames.push(this.totalPermissions[2]);
    } // for EDIT permission
    else if (permission.permissionName === this.totalPermissions[2]) {
      permissionNames.push(this.totalPermissions[1]);
    }// for DELETE/DEACTIVATE permission
    else if (permission.permissionName === this.totalPermissions[3]) {
      permissionNames.push(this.totalPermissions[1]);
    }
    else if (permission.permissionName === this.totalPermissions[4]) {
      permissionNames.push(this.totalPermissions[1]);
    }
    if (permissionNames.length > 0) {
      permissionNames.forEach(name => {
        let permission = group.permissionModels.filter(item => item.permissionName === name)[0];
        if (permission != null) {
          permission.selected = true;
          this.permissionIdStrings.push(group.permissionGroupId + '-' + permission.permissionId)
          let index: number = this.chechBoxChecked.indexOf(permission.permissionId);
          if (index === -1) {
            this.chechBoxChecked.push(permission.permissionId);
          }
        }
      });
    }
    this.setCheckboxesToDisableModeOnLoad();
  }

  onSubmit() {    
    
     let selectedRoles:any[];
     selectedRoles = this.roleIds;
     if(selectedRoles.length===0){
       this.isRolesSelected = true;
     }
     if(this.isRolesSelected==false){
        this.updateUserForm(this.roleIds);
     }
  }

  updateUserForm(selectedRoles:any[]) {
    this.updateUser.departmentId = this.departmentId;
    this.updateUser.operatingCountryId= this.operatingCountryId;
    this.updateUser.userId = this.userId;
    this.updateUser.roleModelIds = selectedRoles;
    this.updateUser.permissionModelIds = this.chechBoxChecked;
    let userId = this._cacheService.get(CacheKey.UserId);
    this.updateUser.loggedinUserId = +userId;
    this.updateUserDetails();
  }

  updateUserDetails() {
    this._departmentService.updateUser(this.updateUser).subscribe(response => {
        if (response.isSuccess) {
            this.message = response.validations != null && response.validations.length > 0 ? response.validations[0].message : '';
            this._commonService.createNotification("", this.message, NotificationType.SUCCESS);
            let managerUserTab = new ManageUserTab();
            managerUserTab.userId = this.userId;
            managerUserTab.departmentID = this.departmentId;
            managerUserTab.closeUserManageTab = true;
            this.messageService.setManageUserTab(managerUserTab);
        }
      else {
        let failed: any = this._translatePipe.get("validation-message.Your attempt to update User is failed");
        this.message = "Your attempt to update User is failed.";
        this._commonService.createNotification("", failed.value, NotificationType.ERROR);
      }
    }, error => {
      let unknown: any = this._translatePipe.get("validation-message.Unknown Error");
      this.message = (error != null && error[0] != null) ? error[0].field + " : " + error[0].message : unknown.value;
      this._commonService.createNotification("", this.message, NotificationType.ERROR);
    });   
  }

  onValueChangeForUpdateUser(event: any) {
    if (event.length != this.dynamicMultiSelectValues.length) {
      let isRemoved: boolean = false;
      let currentItem: number[] = [];
      let currentSelectedValues: number[] = [];
      let priorSelectedValues: number[] = [];
      for (var i = 0; i < event.length; i++) { currentSelectedValues.push(+event[i]); }
      for (var i = 0; i < this.dynamicMultiSelectValues.length; i++) { priorSelectedValues.push(+this.dynamicMultiSelectValues[i]); }
      if (currentSelectedValues.length > priorSelectedValues.length) {
        for (var i = 0; i < currentSelectedValues.length; i++) {
          if (!(priorSelectedValues.indexOf(currentSelectedValues[i]) > -1)) { currentItem.push(currentSelectedValues[i]); }
        }
      }
      else {
        for (var i = 0; i < priorSelectedValues.length; i++) {
          if (!(currentSelectedValues.indexOf(priorSelectedValues[i]) > -1)) { currentItem.push(priorSelectedValues[i]); }
        }
      }
      this.dynamicMultiSelectValues = currentSelectedValues;
      this.clearAllPermissionCheckBoxes();
      if (currentSelectedValues.length > 0) {
        this._departmentService.getPermissionsByRoleIds(currentSelectedValues).subscribe(response => {
          if (response) {
            this.permissions = response;
            if (this.permissions.length > 0) {
              this.departmentLevelPermissionGroupList.forEach(group => {
                let currentGroupPermissionsCount = group.permissionModels.length;
                let count = 0;
                let permissionNames: String[] = [];
                group.permissionModels.forEach(item => {
                  this.permissions.forEach(perm => {
                    if (item.permissionId === perm.permissionId) {
                      count++;
                      let index: number = this.chechBoxChecked.indexOf(item.permissionId);
                      item.selected = true;
                      item.rolePermissionId = perm.rolePermissionId;
                      if (index === -1) {
                        this.chechBoxChecked.push(item.permissionId);
                      }
                    }
                  });
                  if (item.selected) {
                    // for CREATE permission
                    if (item.permissionName === this.totalPermissions[0] || item.permissionName === this.totalPermissions[5]) {

                      permissionNames.push(this.totalPermissions[1]);

                      permissionNames.push(this.totalPermissions[2]);
                    } // for EDIT permission
                    else if (item.permissionName === this.totalPermissions[2]) {

                      permissionNames.push(this.totalPermissions[1]);
                    }// for DELETE/DEACTIVATE permission
                    else if (item.permissionName === this.totalPermissions[3] || item.permissionName === this.totalPermissions[4]) {

                      permissionNames.push(this.totalPermissions[1]);
                    }
                  }
                });
                if (permissionNames.length > 0) {
                  permissionNames.forEach(name => {
                    let permission = group.permissionModels.filter(item => item.permissionName === name)[0];
                    if (permission != null) {
                      this.permissionIdStrings.push(group.permissionGroupId + '-' + permission.permissionId)
                    }
                  });
                }
                if (currentGroupPermissionsCount > 0 && currentGroupPermissionsCount === count) {
                  group.selected = true;
                }
              });
            }
          }
        }
          ,
          // The 2nd callback handles errors.
          (err) => {},
          // The 3rd callback handles the "complete" event.
          () => {
            this.cdRef.detectChanges();
            if (isRemoved)
              this.revertCheckboxesFromDisableModeOnLoad()
            else
              this.setCheckboxesToDisableModeOnLoad();
          }
        );
      }
    }
    else { }
  }

  clearAllPermissionCheckBoxes() {
    this.departmentLevelPermissionGroupList.forEach(group => {
      group.selected = false;
      group.permissionModels.forEach(item => {
        if (item.selected && item.rolePermissionId) {
          this.permissionIdStrings.push(group.permissionGroupId + '-' + item.permissionId);
          let index: number = this.chechBoxChecked.indexOf(item.permissionId);
          item.selected = false;
          if (index !== -1) {
            this.chechBoxChecked.splice(index, 1);
          }
        }
      });
    });
    this.revertCheckboxesFromDisableModeOnLoad()
  } 

   clearFormData(rowState: number): void {
    this.rowStateValue = rowState;
    this.deleteModal.toggle = true;
    this.deleteModal.message = CommonConfig.clearFormData;
    if (rowState == RowStatus.Clear) {
      this.deleteModal.message = CommonConfig.clearFormData;
    }
    this.isRolesSelected = false;
    this.getUserById(this.departmentId, this.userId);
  }

   openDropDown(element:string) {
        var elem = document.getElementById(element)
        var dropDownList = elem.children[0].children[1];
        dropDownList.removeAttribute("hidden");
    }
    onDropDowneBlur(element:string) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.setAttribute("hidden", "true");
    }

    close(evt: any) {
      this.dropdownElem.closeDropdown();
    }

    onItemSelect(item: any, indexValue: any) {
       this.roleIds =[];        
       if (this.dropdownSettings.roleIndex === +indexValue) {
            this.roleOnSelectAll = false;
             if(this.roles.length === this.dropdownSettings.roleSelectedItems.length){
                     this.roleOnSelectAll=true;                   
             }
            this.dropdownSettings.roleSelectedItems.forEach(item => {
                this.roleIds.push(item.id);
             });
             this.onValueChangeForUpdateUser(this.roleIds);
             this.isRolesSelected = false;     
        }       
    }

  
   onItemDeSelect(item: any, indexValue: any) {
     this.roleIds =[];
      if (this.dropdownSettings.roleIndex === +indexValue) {
          this.roleOnSelectAll = false;
      }     
      this.dropdownSettings.roleSelectedItems.forEach(item => {
           this.roleIds.push(item.id);
      }); 
      this.onValueChangeForUpdateUser(this.roleIds);
      this.isRolesSelected = false;
    }

     onSelectAll(items: any, indexValue: any) {
        this.roleIds =[];
        if (this.dropdownSettings.roleIndex === +indexValue) {
            this.roleOnSelectAll = true;
        }    
         this.dropdownSettings.roleSelectedItems.forEach(item => {
                this.roleIds.push(item.id);
          }); 
          this.onValueChangeForUpdateUser(this.roleIds);         
          this.isRolesSelected = false;       
    }

    onDeSelectAll(items: any, indexValue: any) { 
       this.roleIds =[];      
        if (this.dropdownSettings.roleIndex === +indexValue) {
            this.roleOnSelectAll = false;
        } 
        this.onValueChangeForUpdateUser(this.roleIds);
        this.isRolesSelected = false;   
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/department/department-manage-user.component.ts